import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({ 
    name: 'toWords' 
})
export class ToWordsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    let output = _.startCase(value);
    for (const key in REPLACEMENTS) {
      const regex = new RegExp(`\\b${key}\\b`, 'gi');
      output = output.replace(regex, REPLACEMENTS[key]);
    }
    return output;
  }
}

const REPLACEMENTS: Record<string, string> = {
  and: "&"
};
